const variants = { white: 'white', darkBlue: 'darkBlue', coral: 'coral' };
export default variants;
